import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.662.45h-7A1.47 1.47 0 0 0 4.19 1.964q.009.252.022.497h-3.3a.75.75 0 0 0-.75.755c0 2.913 1.047 4.939 2.453 6.313C4 10.886 5.687 11.57 6.931 11.915c.731.204 1.231.818 1.231 1.434a1.19 1.19 0 0 1-1.184 1.192h-.816c-.553 0-1 .45-1 1.007s.447 1.007 1 1.007h6c.553 0 1-.45 1-1.007s-.447-1.007-1-1.007h-.816a1.19 1.19 0 0 1-1.184-1.192c0-.616.497-1.233 1.231-1.434 1.247-.346 2.935-1.029 4.32-2.385 1.402-1.374 2.45-3.4 2.45-6.313a.75.75 0 0 0-.75-.755h-3.3q.012-.243.021-.497A1.47 1.47 0 0 0 12.662.45M1.69 3.971h2.638C4.612 6.806 5.24 8.7 5.95 9.968c-.779-.346-1.588-.834-2.288-1.52-1-.978-1.812-2.39-1.969-4.476zm12.975 4.476c-.7.686-1.51 1.174-2.287 1.52.71-1.268 1.337-3.162 1.622-5.996h2.637c-.16 2.086-.972 3.498-1.969 4.476z" }, null, -1)
  ]))]))
}
export default { render: render }